/*
 * The recruiter app's entry component.
 *
 * The shell, the guard, the not-found screen and the router construction are `./app/*`; this file
 * is what `main.tsx` mounts and nothing else. `App`'s import surface is unchanged — `main.tsx` still
 * does `import { App } from './app.js'` — so the split is invisible from outside.
 *
 * The routing table is still ROUTES and still nowhere else. `./app/router.tsx` maps it; a route
 * added anywhere but the manifest would be invisible to FE-02's gate, which is why there is no way
 * to add one anywhere but the manifest.
 */

import { useMemo } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { buildRouter } from './app/router.js';
import { AppErrorBoundary } from './app/error-screen.js';

export function App() {
  // Built once. Rebuilding on render would remount every screen on every session change.
  const router = useMemo(buildRouter, []);

  // Outside the router on purpose. The router's own `defaultErrorComponent` catches anything a
  // screen throws; nothing inside the router can catch a throw from the router itself, or from a
  // provider above the route tree, which is the gap this closes.
  return (
    <AppErrorBoundary>
      <RouterProvider router={router} />
    </AppErrorBoundary>
  );
}
